import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getObligationList as getObligationListApi,
	getObligation as getObligationApi,
	addNewObligation as addNewObligationApi,
	updateObligation as updateObligationApi,
	deleteObligation as deleteObligationApi,
} from '../../helpers/normative/backend_helper';

export const getObligationList = createAsyncThunk('obligations/getObligationList', async () => {
	try {
		const response = getObligationListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getObligation = createAsyncThunk('obligations/getObligation', async obligation_id => {
	try {
		const response = getObligationApi(obligation_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewObligation = createAsyncThunk('obligations/addNewObligation', async obligation => {
	try {
		const response = addNewObligationApi(obligation);
		toast.success('Obligation agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar obligation.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateObligation = createAsyncThunk('obligations/updateObligation', async (obligation) => {
		try {
			const response = updateObligationApi(obligation);
			toast.success('Obligation actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar obligation.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteObligation = createAsyncThunk('obligations/deleteObligation', async obligation => {
	try {
		const response = await deleteObligationApi(obligation);
		toast.success('Obligation eliminado exitosamente.', { autoClose: 3000 });
		return { obligation, ...response };
	} catch (error) {
		toast.error('Error al eliminar obligation.', { autoClose: 3000 });
		throw new Error(error);
	}
});
